// Name of the non-HttpOnly cookie set by auth.connect alongside the
// CloudFront signed cookies. JS-readable, scoped to `.duke.co`, drives the
// optimistic-render path in `FilesTrpcClientProvider` so returning users
// skip the file-service auth splash on first paint.
//
// Avoids the `duke:` prefix used by session cookies — those are set and
// consumed only by Fastify; this one crosses domain boundaries (set by
// file.duke.co, parsed at SSR by app.duke.co's Next.js) and a colon in a
// cookie name is an RFC 6265 separator that some parsers reject.
export const CDN_READY_COOKIE_NAME = 'duke-cdn-ready';
